import React from "react";
import CommonTable from "../../../../common/commonTable";
import {
  AllPagination,
  CommonFilters,
  TitleHeader,
} from "../../../../components";
import useVerificationrequestedList from "./verificationrequestedlistUtils";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";

const columns = [
  { label: "Name", key: "name" },
  { label: "Email", key: "email" },
  { label: "Phone Number", key: "phone_number" },
  { label: "City", key: "city" },
  { label: "Customer Type", key: "customer_type" },
  { label: "Status", key: "status" },
];

const VerificationRequestedList = () => {
  const {
    listData,
    loading,
    currentPage,
    limit,
    fetchCustomerData,
    handleSearch,
    handleFilter,
    handlePageChange,
  } = useVerificationrequestedList();

  const navigate = useNavigate();

  const actions = (item) => [
    {
      title: "Edit",
      icon: <EditIcon />,
      action: () => navigate(`/customer/edit/${item.id}`),
    },
  ];

  return (
    <>
      <TitleHeader
        heading="Welcome to Jayeek!  "
        buttonText="+ Add New"
        // onButtonClick={}
      />
      <div className="page-card-bg table-data-new">
        <CommonFilters
          heading="Verification Requested List"
          handleSearch={handleSearch}
          handleFilter={handleFilter}
          placeholderText="Search By Name"
          filterFields={[
            {
              name: "status",
              label: "Status",
              type: "autocomplete",
              options: [
                { title: "Active", id: "Active" },
                { title: "Deactive", id: "Deactive" },
              ],
              placeholder: "Select Status",
            },

           

            {
              name: "customer_type",
              label: "Customer Type",
              type: "autocomplete",
              options: [
                { title: "Driver", id: "Driver" },
                { title: "Client", id: "Client" },
              ],
              placeholder: "Select Type",
            },
          ]}
        />

        <CommonTable
          columns={columns}
          data={
            listData?.docs?.map((doc) => ({
              ...doc,
              city: doc?.getCity?.name || "",
            })) || []
          }
          loading={loading}
          actions={actions}
        />

        {listData?.pages > 1 && (
          <AllPagination
            totalPages={listData?.pages}
            currentPage={currentPage}
            totalRecords={listData?.pages}
            onPageChange={handlePageChange}
            limit={limit}
          />
        )}
      </div>
    </>
  );
};

export default VerificationRequestedList;
